import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  private lastAction: string = '';
  private numeroPagina: any;
  private rangoPaginas: any;

  actionCount: number = 0;

  constructor() { }
 
  getPagination(currentPage: any, rango: number, buscar: any, estatus: any, proyecto: any, ventana: any, anio?: any, mes?: any){

    if(this.lastAction !== 'back'){
      this.numeroPagina = currentPage;
      this.rangoPaginas = rango;
    }

    return this.guardarPaginacion(buscar, estatus, proyecto, ventana, anio, mes);
  }

  guardarPaginacion(buscar: any, estatus: any, proyecto: any, ventana: any, anio: any, mes?: any) {
    // Configuración base de la paginación
    const pagination = {
      page: this.numeroPagina,
      pageSize: this.rangoPaginas
    };
  
    // Mapeo de los filtros según el valor de 'ventana'
    let filters: any;
  
    switch (ventana) {
      case 'factura':
        filters = {
          FacPro_NoFactura: buscar,
          FacPro_VoBo: estatus,
          FKId_Proyecto: proyecto,
          FacPro_MesServicio: mes,
          ano: anio
        };
      break;

      case 'refactura':
        filters = {
          FacPro_NoFactura: buscar,
          FacPro_VoBo: estatus,
          FKId_Proyecto: proyecto,
          FacPro_MesServicio: mes,
          FacPro_AnoIngreso: anio
        };
      break;
      
      case 'deductiva':
      case 'penalizacion':
        filters = {
          Id_DedPen: buscar,
          DepPen_VoBo: estatus,
          FKId_Proyecto: proyecto,
          DedPen_Mes: mes,
          DedPen_Ano: anio
        };
        break;
  
      default:
        return null; // Manejo de caso nulo
    }
  
    // Retornar el objeto final con paginación y filtros
    return {
      pagination,
      filters
    };
  }

  setLastAction(action: string) {
    this.lastAction = action;
  }

  getLastAction(): any {
    return {
      lastAction: this.lastAction,
      numeroPagina: this.numeroPagina,
      rangoPaginas: this.rangoPaginas
    };
  }

}
